import { render, staticRenderFns } from "./dimensionsSelect.vue?vue&type=template&id=0bd9fa68"
import script from "./dimensionsSelect.vue?vue&type=script&lang=js"
export * from "./dimensionsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports